import React from 'react';
import ComponentCreator from '@docusaurus/ComponentCreator';

export default [
  {
    path: '/autoviews/docs',
    component: ComponentCreator('/autoviews/docs', 'd5e'),
    routes: [
      {
        path: '/autoviews/docs',
        component: ComponentCreator('/autoviews/docs', '704'),
        exact: true,
        sidebar: "mySidebar"
      },
      {
        path: '/autoviews/docs',
        component: ComponentCreator('/autoviews/docs', '879'),
        exact: true
      },
      {
        path: '/autoviews/docs/basic/autoview',
        component: ComponentCreator('/autoviews/docs/basic/autoview', 'ebe'),
        exact: true,
        sidebar: "mySidebar"
      },
      {
        path: '/autoviews/docs/entities/array-components',
        component: ComponentCreator('/autoviews/docs/entities/array-components', 'dcd'),
        exact: true,
        sidebar: "mySidebar"
      },
      {
        path: '/autoviews/docs/entities/components-repo',
        component: ComponentCreator('/autoviews/docs/entities/components-repo', '3cf'),
        exact: true,
        sidebar: "mySidebar"
      },
      {
        path: '/autoviews/docs/entities/events',
        component: ComponentCreator('/autoviews/docs/entities/events', 'ea0'),
        exact: true,
        sidebar: "mySidebar"
      },
      {
        path: '/autoviews/docs/entities/object-components',
        component: ComponentCreator('/autoviews/docs/entities/object-components', 'c6d'),
        exact: true,
        sidebar: "mySidebar"
      },
      {
        path: '/autoviews/docs/entities/repository-components',
        component: ComponentCreator('/autoviews/docs/entities/repository-components', '209'),
        exact: true,
        sidebar: "mySidebar"
      },
      {
        path: '/autoviews/docs/entities/repository-provider',
        component: ComponentCreator('/autoviews/docs/entities/repository-provider', '461'),
        exact: true,
        sidebar: "mySidebar"
      },
      {
        path: '/autoviews/docs/entities/the-json-schema',
        component: ComponentCreator('/autoviews/docs/entities/the-json-schema', '48c'),
        exact: true,
        sidebar: "mySidebar"
      },
      {
        path: '/autoviews/docs/entities/ui-schema',
        component: ComponentCreator('/autoviews/docs/entities/ui-schema', '3bf'),
        exact: true,
        sidebar: "mySidebar"
      },
      {
        path: '/autoviews/docs/examples',
        component: ComponentCreator('/autoviews/docs/examples', '2d8'),
        exact: true,
        sidebar: "examples"
      },
      {
        path: '/autoviews/docs/examples/basic',
        component: ComponentCreator('/autoviews/docs/examples/basic', '55e'),
        exact: true,
        sidebar: "examples"
      },
      {
        path: '/autoviews/docs/examples/layout',
        component: ComponentCreator('/autoviews/docs/examples/layout', '9a8'),
        exact: true,
        sidebar: "examples"
      },
      {
        path: '/autoviews/docs/examples/onclick',
        component: ComponentCreator('/autoviews/docs/examples/onclick', 'be0'),
        exact: true,
        sidebar: "examples"
      },
      {
        path: '/autoviews/docs/examples/showcase',
        component: ComponentCreator('/autoviews/docs/examples/showcase', 'b7b'),
        exact: true,
        sidebar: "examples"
      },
      {
        path: '/autoviews/docs/examples/switch-repo',
        component: ComponentCreator('/autoviews/docs/examples/switch-repo', '35b'),
        exact: true,
        sidebar: "examples"
      },
      {
        path: '/autoviews/docs/examples/table-with-header',
        component: ComponentCreator('/autoviews/docs/examples/table-with-header', 'a6b'),
        exact: true,
        sidebar: "examples"
      },
      {
        path: '/autoviews/docs/subschemas',
        component: ComponentCreator('/autoviews/docs/subschemas', '6cd'),
        exact: true,
        sidebar: "mySidebar"
      },
      {
        path: '/autoviews/docs/subschemas/combiners-oneof',
        component: ComponentCreator('/autoviews/docs/subschemas/combiners-oneof', '213'),
        exact: true,
        sidebar: "mySidebar"
      },
      {
        path: '/autoviews/docs/subschemas/combiners-ref',
        component: ComponentCreator('/autoviews/docs/subschemas/combiners-ref', '187'),
        exact: true,
        sidebar: "mySidebar"
      },
      {
        path: '/autoviews/docs/subschemas/conditions',
        component: ComponentCreator('/autoviews/docs/subschemas/conditions', '2c3'),
        exact: true,
        sidebar: "mySidebar"
      }
    ]
  },
  {
    path: '/autoviews/',
    component: ComponentCreator('/autoviews/', '3e4'),
    exact: true
  },
  {
    path: '*',
    component: ComponentCreator('*'),
  },
];
